import React, {useContext } from "react";
import StoreContext from "./../Componentes/Store/Context";
import { reactLocalStorage } from "reactjs-localstorage";
import sha256 from "crypto-js/sha256";
import {Decimal} from 'decimal.js';
import hmacSHA512 from "crypto-js/hmac-sha512";
import Base64 from "crypto-js/enc-base64";
import moment from "moment";
import {IconStore} from "./www/Icons"
import {LOGO, LOGO_2, LOGO_RESTAURANTE} from "./Image";
import { mkConfig, generateCsv, download } from 'export-to-csv';
import {Container, Label, Row, Col, NavLink,Button  } from "reactstrap";
import {MDBInput,MDBBtn,MDBTextArea, MDBIcon,MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalBody, MDBModalFooter} from "mdb-react-ui-kit";
import {Box,IconButton, Menu, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { nonce, path, privateKey,post_dc_compra_detalle_row,put_dcd_compra_detalle_row,post_ord_orden,put_facturado_orden,
  post_red_recuento_detalle,put_red_recuento_detalle_row,post_facturaElectronica,post_fac_factura,postAnular,post_AnulacionElectronica,put_cli_cliente,
  imgURLocalImage,
  put_mov_movimiento_detalle_row,
  put_movd_movimiento_detalle,
  post_movd_movimiento_detalle,
  put_ord_number} from "./Services";
import { COLUMNS_BODEGAS, COLUMNS_FAC_FACTURA_DETALLE_COPIA } from "./DatatableColumns";
import {
  MaterialReactTable,
  MRT_EditActionButtons as MrtEditActionButtons,
} from "material-react-table";

  function format_miles({num}) {
    return Number(num)<1000?(Math.round(new Intl.NumberFormat('es-MX').format(num) * 100) / 100).toFixed(2): new Intl.NumberFormat('es-MX').format(Number(num).toFixed(2))
  }

  function roundNumber(num, scale) {
    if(!("" + num).includes("e")) {
      return +(Math.round(num + "e+" + scale)  + "e-" + scale);
    } else {
      var arr = ("" + num).split("e");
      var sig = ""
      if(+arr[1] + scale > 0) {
        sig = "+";
      }
      return + (Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
  }
  function BODY_DC_COMPRA({dataCompraDetalle,formCompra,formDropDownProveedor,usr_sucursal,usr_id}) {
    var totalPrecioNeto=0;
    var totalITBMS = 0;
    var dataDC_detail = dataCompraDetalle.map((val, i) => {
      totalPrecioNeto = Number(totalPrecioNeto) + (Number(val.dcd_cantidad) * Number(val.dcd_precio));//Suma de todas las ocurrencias de PrecioItem.
      totalITBMS = Number(totalITBMS) + Number(val.dcd_itbms);//Suma de todas las ocurrencias de ValorITBMS.
      return {
        dcd_identificador: formCompra.dc_identificador,
        dcd_sucursal:usr_sucursal,
        dcd_articulo: val.dcd_articulo,
        dcd_articulo_desc:val.art_descripcion,	
        dcd_precio: val.dcd_precio,
        dcd_cantidad: val.dcd_cantidad,
        dcd_itbms: val.dcd_itbms,
        dcd_descuento: val.dcd_descuento,
        dcd_total:val.dcd_total,
        dcd_descuento_number: val.dcd_descuento,
        dcd_unique:formCompra.dc_identificador+"_"+val.dcd_articulo+"_"+i ,
        dcd_serie:val.art_serie
      };
    });
    var body = {
      formCompra: {
        dc_docn: formCompra.dc_docn,
        dc_identificador: formCompra.dc_identificador,
        dc_suc:usr_sucursal,
        dc_usuario:usr_id,
        dc_proveedor: formDropDownProveedor.prov_id,
        dc_bodega: formDropDownProveedor.bod_id,
        dc_fecha: formCompra.dc_fecha,
        dc_descripcion: formCompra.dc_descripcion,
        dc_itbms:totalITBMS.toFixed(4),
        dc_total:(Number(totalPrecioNeto)+Number(totalITBMS)).toFixed(2),
        dc_unique:formCompra.dc_identificador,
      },
      dataCompraDetalle: dataDC_detail,
    };
    return body;
  }
  function DC_UPDATE_CANTIDAD({dataCompraDetalle,formCompraDetalle,formCompra}){
    var flag = false;
    var itbms=0;
    var cantidad =0;
    var qty_articulo =0
    var objItems = dataCompraDetalle.filter((data, i) => {
      if(data.dcd_articulo === formCompraDetalle.dcd_articulo){
        qty_articulo =Number(qty_articulo) + 1
      }
      if (data.dcd_articulo === formCompraDetalle.dcd_articulo && data.art_descripcion === formCompraDetalle.art_descripcion && data.art_serie === formCompraDetalle.art_serie) {
        flag = true;
        cantidad = Number(data.dcd_cantidad) + Number(formCompraDetalle.dcd_cantidad);
        itbms = (new Decimal(cantidad).times(new Decimal(data.dcd_precio))).times(new Decimal(data.art_itbm_compra));
        data.dcd_cantidad = cantidad;
        data.dcd_itbms = itbms;
        data.dcd_total =(new Decimal(cantidad).times(new Decimal(formCompraDetalle.dcd_precio))).plus(new Decimal(itbms));

        return data;
      }});
    if (!flag) {
      itbms = (new Decimal(formCompraDetalle.dcd_cantidad).times(new Decimal(formCompraDetalle.dcd_precio))).times(new Decimal(formCompraDetalle.art_itbm_compra));
      var bodyInsertRow={
        dcd_identificador:formCompra.dc_identificador,
        dcd_articulo:formCompraDetalle.dcd_articulo,	
        dcd_precio:formCompraDetalle.dcd_precio,	
        dcd_articulo_desc:formCompraDetalle.art_descripcion,	
        dcd_cantidad:	formCompraDetalle.dcd_cantidad,
        dcd_serie:formCompraDetalle.art_serie,
        dcd_itbms:itbms,	
        dcd_total:(new Decimal(formCompraDetalle.dcd_cantidad).times(new Decimal(formCompraDetalle.dcd_precio))).plus(new Decimal(itbms)),
        dcd_unique:formCompra.dc_identificador+"_"+formCompraDetalle.dcd_articulo+"_"+(formCompraDetalle.art_serie.length>0?formCompraDetalle.art_serie:qty_articulo>0?qty_articulo:"0")
      }
     
      post_dc_compra_detalle_row(bodyInsertRow)
    } else {
      var bodyInsertRow={
        dcd_id:objItems[0].dcd_id,
        dcd_identificador:formCompra.dc_identificador,
        dcd_articulo:formCompraDetalle.dcd_articulo,	
        dcd_articulo_desc:formCompraDetalle.art_descripcion,	
        dcd_precio:formCompraDetalle.dcd_precio,	
        dcd_cantidad: Number(objItems[0].dcd_cantidad),
        dcd_itbms:Number(objItems[0].dcd_itbms),	
        dcd_total:Number(objItems[0].dcd_total),	
        dcd_serie:formCompraDetalle.art_serie,
      }
      put_dcd_compra_detalle_row(bodyInsertRow)
    }
  }

  function BODY_MOV_MOVIMIENTO({dataMovimientoDetalle,formMovimiento}) {
    var dataMov_movimiento_detalle = dataMovimientoDetalle.map((val, i) => {
      return {
        movd_identificador: formMovimiento.mov_identificador,
        movd_articulo: val.movd_articulo,
        movd_cantidad:val.movd_cantidad,	
        movd_unique:formMovimiento.mov_identificador+"_"+val.movd_articulo+"_"+i,
        movd_serie: val.art_serie,
      };
    });

    var body = {
      formMovimiento: {
        mov_identificador: formMovimiento.mov_identificador,
        mov_fecha: formMovimiento.mov_fecha,
        mov_descripcion: formMovimiento.mov_descripcion,
        mov_unique:formMovimiento.mov_identificador,
        mov_bodega_desde:formMovimiento.mov_bodega_desde,
        mov_bodega_hacia:formMovimiento.mov_bodega_hacia,
        mov_fecha_procesado: "",
      },
      dataMovimientoDetalle: dataMov_movimiento_detalle,
    };
    return body;
  }

  function BODY_RE_RECUENTO({dataRecuentoDetalle,formRecuento,usr_sucursal,formDropDownInv,usr_id}) {

    var dataRed_Recuento_detalle = dataRecuentoDetalle.map((val, i) => {
      return {
        red_identificador: formRecuento.re_identificador,
        red_articulo: val.red_articulo,
        red_serie: val.art_serie,
        red_cantidad:val.red_cantidad,	
        red_unique:formRecuento.re_identificador+"_"+val.red_articulo+"_"+i 
      };
    });

    var body = {
      formRecuento: {
        re_identificador: formRecuento.re_identificador,
        re_sucursal:usr_sucursal,
        re_usuario:usr_id,
        re_bodega:formDropDownInv.bod_id,
        re_descripcion: formRecuento.re_descripcion,
        re_unique:formRecuento.re_identificador,
      },
      dataRecuentoDetalle: dataRed_Recuento_detalle,
    };
    return body;
  }
  
  function RE_UPDATE_CANTIDAD({dataRecuentoDetalle,formRecuentoDetalle,formRecuento}){
    var flag = false;
    var cantidad =0;
    var qty_articulo =0

    var objItems = dataRecuentoDetalle.filter((data, i) => {
      if(data.dcd_articulo === formRecuentoDetalle.dcd_articulo){
        qty_articulo =Number(qty_articulo) + 1
      }
      if (data.red_articulo === formRecuentoDetalle.red_articulo && data.art_descripcion === formRecuentoDetalle.art_descripcion && data.art_serie === formRecuentoDetalle.art_serie) {
        flag = true;
        cantidad = Number(data.red_cantidad) + Number(formRecuentoDetalle.red_cantidad);
        data.red_cantidad = Number(cantidad).toFixed(2);
        return data;
      }});
    if (!flag) {
      var body={
        red_identificador:formRecuento.re_identificador,
        red_articulo:formRecuentoDetalle.red_articulo,
        red_serie:formRecuentoDetalle.art_serie,
        red_cantidad:formRecuentoDetalle.red_cantidad,
        red_unique:formRecuento.re_identificador+"_"+formRecuentoDetalle.red_articulo+"_"+(formRecuentoDetalle.art_serie.length>0?formRecuentoDetalle.art_serie:qty_articulo>0?qty_articulo:"0")
      }
      post_red_recuento_detalle(body)
    } else {
      var body={
        red_id:objItems[0].red_id,
        red_identificador:formRecuento.re_identificador,
        red_articulo:formRecuentoDetalle.red_articulo,	
        red_serie:formRecuentoDetalle.art_serie,
        red_cantidad: Number(objItems[0].red_cantidad),
      }
      put_red_recuento_detalle_row(body)
    }
  }
  
  function MOV_UPDATE_CANTIDAD({dataMovimientoDetalle,formMovimientoDetalle,formMovimiento}){
    var flag = false;
    var cantidad =0;
    var qty_articulo =0;
    var objItems = dataMovimientoDetalle.filter((data, i) => {
      if(data.dcd_articulo === formMovimientoDetalle.dcd_articulo){
        qty_articulo =Number(qty_articulo) + 1
      }
      if (data.movd_articulo === formMovimientoDetalle.movd_articulo && data.art_descripcion === formMovimientoDetalle.art_descripcion && data.art_serie === formMovimientoDetalle.art_serie) {
        flag = true;
        cantidad = Number(data.movd_cantidad) + Number(formMovimientoDetalle.movd_cantidad);
        data.movd_cantidad = Number(cantidad).toFixed(2);
        return data;
      }});
    if (!flag) {
      var body={
        // movd_id:formMovimientoDetalle.movd_id,
        movd_identificador:formMovimiento.mov_identificador,
        movd_articulo:formMovimientoDetalle.movd_articulo,
        movd_cantidad:formMovimientoDetalle.movd_cantidad,
        movd_serie:formMovimientoDetalle.art_serie,
        movd_unique:formMovimiento.mov_identificador+"_"+(formMovimientoDetalle.art_serie.length>0?formMovimientoDetalle.art_serie:qty_articulo>0?qty_articulo:"0")
      }
      post_movd_movimiento_detalle(body)
    } else {
      var body={
        movd_id:objItems[0].movd_id,
        movd_identificador:formMovimientoDetalle.movd_identificador,
        movd_articulo:formMovimientoDetalle.movd_articulo,	
        movd_cantidad: Number(objItems[0].movd_cantidad),
        movd_serie:formMovimientoDetalle.art_serie,
      }
      put_mov_movimiento_detalle_row(body)
    }
  }
  function FORMATO_AM_PM(date) {
    var dates = moment(date).format("YYYY-MM-DD");
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return dates + " " +strTime;
  }
  function SET_DATA_COMPANY({data}){
    return {
      com_ruc:data.com_ruc +" DV " +data.com_dv,
      com_nombre:data.com_nombre,
      com_direccion:data.com_direccion,
      com_telefono:data.com_telefono,
      com_telefono2:data.com_telefono2,
      com_email:data.com_email,
      com_web:data.com_web,
      com_logo:data.com_logo
    }
  }
  function COPIA_FACTURA({formGarantia,dataFac,dataFpago,dataCompania,dataSelected,usr_prints,com_suc_emisor,punto_facturacion}){
    var ObjFPago = [];
    var ObjItems = [];
    var totalValorRecibido=0;
    var totalPrecioNeto=0;
    var totalITBMS = 0;
    var totaldescuento = 0;
    var nroItems=0;
    var vueltoR=0;
    var montoEntregado =0;
    var  retencion={
      codigoRetencion:"",
      montoRetencion:"",
    };
    var dataCompany = SET_DATA_COMPANY({data:dataCompania})
    dataFac.map((data)=>{
      totalPrecioNeto = (new Decimal(data.fcd_cantidad).times(new Decimal(data.fcd_precio))).plus(totalPrecioNeto);//Suma de todas las ocurrencias de PrecioItem.3 decimales
      totalITBMS = new Decimal(data.fcd_itbms).plus(new Decimal (totalITBMS));//Suma de todas las ocurrencias de ValorITBMS. 3 decimales
      totaldescuento = new Decimal(data.fcd_descuento).plus(new Decimal (totaldescuento)); //3 decimales

      totalValorRecibido = Number(data.fcd_entregado);
      nroItems = nroItems + 1;
      ObjItems.push({
        descripcion: data.fcd_art_descripcion,
        codigo: data.art_upc.slice(0, 19),
        cantidad: Number(data.fcd_cantidad).toFixed(2),
        precioUnitario: Number(data.fcd_precio).toFixed(2),
        unidadMedida:"und",
        precioUnitarioDescuento:new Decimal(data.fcd_descuento).dividedBy(new Decimal(data.fcd_cantidad)).toFixed(2),
        precioItem:new Decimal(data.fcd_cantidad).times(new Decimal(data.fcd_precio).minus(new Decimal(data.fcd_descuento).dividedBy(new Decimal(data.fcd_cantidad)))).toFixed(2),//PrecioItem <> Cantidad * (PrecioUnitario - PrecioUnitarioDescuento)
        valorTotal:Number(data.fcd_total).toFixed(2),//Suma del precio del ítem con los montos de los impuestos
        tasaITBMS: data.fcd_itbms_code,//Tasa del ITBMS aplicable al ítem. 00:0% (exento) 01:7% 02:10% 03:15%
        valorITBMS: Number(data.fcd_itbms).toFixed(3),//Monto del ITBMS del ítem. Producto de TasaITBMS * PrecioItem
      });
    });

    dataFpago.map((data,i)=>{
      ObjFPago.push({
        formaPagoFact:data.fcfp_number,
        descFormaPago:data.fcfp_number==="99"?data.fcfp_fpago:null,
        valorCuotaPagada:Number(data.fcfp_monto).toFixed(2),
        descFormaPagoR:data.fcfp_fpago
      });
      montoEntregado = new Decimal(data.fcfp_monto).plus(new Decimal(montoEntregado));
    });

    vueltoR = new Decimal(totalValorRecibido).minus((new Decimal(totalPrecioNeto).minus(new Decimal(totaldescuento)).plus(totalITBMS)));

    var bodyFactura = {
      prefactura:false,
      res_mesa_id:"",
      tipoDocumento:dataSelected.fac_tipodocumento,
      fac_anulacion:false,
      codigoSucursalEmisor:com_suc_emisor,
      cufeFEReferenciada:"",
      motivo_anulacion:"",
      fac_id:dataSelected.fac_id,
      nota_credito:false,
      punto_facturacion,
      fac_docn:dataSelected.fac_tipodocumento==="04"?dataSelected.fac_doc_nc.toString().padStart(10, "0"):dataSelected.fac_id.toString().padStart(10, "0"),
      fac_fecha:dataSelected.fac_fecha,
      fac_cufe:dataSelected.fac_cufe,
      cli_email:dataSelected.cli_email.length>12?dataSelected.cli_email:null,
      cli_ruc:dataSelected.cli_ruc,
      cli_name:dataSelected.cli_nombre,
      cli_dv:dataSelected.cli_dv,
      cli_direccion:dataSelected.cli_direccion,
      listaItems:ObjItems,
      fac_text_invoice:dataSelected.fac_text_invoice,
      totaldescuento:Number(totaldescuento).toFixed(2),
      totalPrecioNeto:Number(totalPrecioNeto).toFixed(2),
      totalITBMS:roundNumber(Number(totalITBMS),2).toFixed(2),
      totalMontoGravado:Number(totalITBMS).toFixed(2),
      totalFactura:MONEY_ROUND(Number(totalPrecioNeto)-Number(totaldescuento) + roundNumber(Number(totalITBMS),3)),////Suma de TotalTodosItems, TotalAcarreoCobrado, ValorSeguroCobrado menos TotalDescuento.
      totalTodosItems:MONEY_ROUND(Number(totalPrecioNeto) - Number(totaldescuento) + Number(totalITBMS)),
      nroItems,
      retencion,
      valorCuotaPagada:MONEY_ROUND(Number(totalPrecioNeto)+Number(totalITBMS)),
      totalValorRecibido:totalValorRecibido.toFixed(2),//(Number(totalPrecioNeto) + Number(totalITBMS)).toFixed(2),
      vuelto: Number(vueltoR)<=0?"0.00":vueltoR.toFixed(2),//"0.00",
      print_type:usr_prints, //1. pdf, 2.recibo 3. recibo no fiscal
      informacionInteres: formGarantia.gr_descripcion+" \n"+ dataCompania.com_info_interes,
      listaFormaPago:ObjFPago,
      dataCompany,
      props_anulacion:[],
      facCopia:true,
    }
                   const datas = {
  empresa: "MTECHNOLOGY",
  factura: "001-000123",
  cliente: "Consumidor Final",
  productos: [
    { nombre: "Cable USB", cantidad: 1, total: 5.00 },
    { nombre: "Mouse", cantidad: 1, total: 8.00 }
  ],
  subtotal: 13.00,
  itbms: 0.91,
  total: 13.91
};

window.location.href = "mtcprint://print?json=" + encodeURIComponent(JSON.stringify(bodyFactura));
    post_facturaElectronica({data:bodyFactura,formRestaurante:"",isPost:false,data_fac_factura:[]});

  }
  function GUARDAR_ORDEN_NORMAL({dataFac,formFactura,dataOrden,is_restaurante,formClientes,usr_sucursal}){
    var dataOrden_detail = dataFac.map((data,i)=>{
      return {
        ordd_identificador: formFactura.fac_identificador,
        ordd_articulo: data.fcd_articulo,
        ordd_precio: data.fcd_precio,
        ordd_cantidad: data.fcd_cantidad,
        ordd_art_descripcion: data.art_descripcion,
        ordd_itbms_code: data.art_itbm_cod_v,
        ordd_itbms: data.fcd_itbms,
        ordd_descuento: data.fcd_descuento,
        ordd_total: data.fcd_total,//(new Decimal(data.fcd_cantidad).times(new Decimal(data.fcd_precio))).plus(new Decimal(data.fcd_itbms)),
        ordd_descuento_number: data.fcd_descuento_number,
        ordd_unique:formFactura.fac_identificador+"_"+data.fcd_articulo+"_"+i
      };
    });

    var body = { 
      formOrden: {
        ord_identificador: formFactura.fac_identificador,
        ord_mesa: "0" ,
        ord_vendedor:formFactura.fac_vendedor,
        ord_cliente:formClientes.cli_id,
        ord_fecha:formFactura.fac_fecha,
        ord_unique:formFactura.fac_identificador,
         ord_sucursal:usr_sucursal,
        ord_restaurante:"0"
      },
      dataOrdenDetalle: dataOrden_detail,
    };
    post_ord_orden(body);
  }
  function GUARDAR_ORDEN_RESTAURANTE({dataFac,formFactura,dataOrden,is_restaurante,usr_sucursal,usr_id}){
    var totalPrecioNeto=0;
    var totalITBMS = 0;
    var identificador = moment(new Date()).format("YYYYMMDDHHmmssSSS");
    var dataOrden_detail = dataFac.map((data,i)=>{
      totalPrecioNeto = Number(totalPrecioNeto) + (Number(data.ordd_cantidad) * Number(data.ordd_precio));//Suma de todas las ocurrencias de PrecioItem.
      totalITBMS = Number(totalITBMS) + roundNumber(Number(data.ordd_itbms),3);//Suma de todas las ocurrencias de ValorITBMS.
      return {
        ordd_identificador: identificador,
        ordd_articulo: data.ordd_articulo,
        ordd_precio: data.ordd_precio,
        ordd_cantidad: data.ordd_cantidad,
        ordd_art_descripcion: data.art_descripcion,
        ordd_itbms_code: data.art_itbm_cod_v,
        ordd_itbms: roundNumber(data.ordd_itbms,2),
        ordd_descuento: data.ordd_descuento,
        ordd_total:roundNumber((Number(data.ordd_cantidad) * Number(data.ordd_precio))+(Number(data.ordd_itbms)),2) ,
        ordd_descuento_number: data.ordd_descuento,
        ordd_unique:identificador+"_"+data.ordd_articulo+"_"+i
      };
    });

    var body = { 
      formOrden: {
        ord_identificador: identificador,
        ord_mesa: is_restaurante?dataOrden.res_mesa_id:"0" ,
        ord_vendedor:usr_id,
        ord_fecha:moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        ord_unique:identificador,
        ord_sucursal:usr_sucursal,
        ord_restaurante:"1"
      },
      dataOrdenDetalle: dataOrden_detail,
    };
    post_ord_orden(body);
  }
  async function GUARDAR_FACTURA({formRetencion,formGarantia,formRestaurante,dataFac,dataFpago,prefactura,dataCompania,formFactura,formDropDownFPago,formClientes,usr_prints,usr_sucursal,com_suc_emisor,punto_facturacion,caj_id}){
    var ObjItems = [];
    var ObjFPago = [];
    var retencion = {};
    var Objfactura_fpago = [];
    var totalValorRecibido=0;
    var totalPrecioNeto=0;
    var totalITBMS = 0;
    var totaldescuento = 0;
    var nroItems=0;
    var vueltoR=0;
    var montoEntregado =0;
    var montoCredito = 0;
    var isCreditV=false;
    var dataCompany = SET_DATA_COMPANY({data:dataCompania})
    dataFpago.map((data,i)=>{
      Objfactura_fpago.push({
        fcfp_identificador:formFactura.fac_identificador,
        fcfp_number:data.list_fpago,
        fcfp_fpago:data.list_fpagoName,
        fcfp_monto:data.list_monto,
        fcfp_sucursal:usr_sucursal,
        fcfp_unique:formFactura.fac_identificador+data.list_fpago
      });

      ObjFPago.push({
        formaPagoFact:data.list_fpago,
        descFormaPago:data.list_fpago==="99"?data.list_fpagoName:null,
        valorCuotaPagada:Number(data.list_monto).toFixed(2),
        descFormaPagoR:data.list_fpagoName
      })
      montoEntregado = new Decimal(data.list_monto).plus(new Decimal(montoEntregado));
      totalValorRecibido = new Decimal(data.list_monto).plus(new Decimal(totalValorRecibido));
      if(data.list_fpago==="01"){
        montoCredito=data.list_monto;
        isCreditV= true;
      }
    });
    var dataFAC_detail = dataFac.map((data,i)=>{
      totalPrecioNeto = (new Decimal(data.fcd_cantidad).times(new Decimal(data.fcd_precio))).plus(totalPrecioNeto);//Suma de todas las ocurrencias de PrecioItem.3 decimales
      totalITBMS = new Decimal(data.fcd_itbms).plus(new Decimal (totalITBMS));//Suma de todas las ocurrencias de ValorITBMS. 3 decimales
      totaldescuento = new Decimal(data.fcd_descuento).plus(new Decimal (totaldescuento)); //3 decimales
      nroItems = nroItems + 1;
      ObjItems.push({
        descripcion: data.art_descripcion,
        codigo: data.art_upc.slice(0, 19),
        unidadMedida:"und",
        cantidad: Number(data.fcd_cantidad).toFixed(2),
        precioUnitario: Number(data.fcd_precio).toFixed(2),
        precioUnitarioDescuento:new Decimal(data.fcd_descuento).dividedBy(new Decimal(data.fcd_cantidad)).toFixed(2),
        precioItem:new Decimal(data.fcd_cantidad).times(new Decimal(data.fcd_precio).minus(new Decimal(data.fcd_descuento).dividedBy(new Decimal(data.fcd_cantidad)))).toFixed(2),//PrecioItem <> Cantidad * (PrecioUnitario - PrecioUnitarioDescuento)
        valorTotal:Number(data.fcd_total).toFixed(2),
        tasaITBMS: formClientes.cli_exento==="1"?"00":data.art_itbm_cod_v,//Tasa del ITBMS aplicable al ítem. 00:0% (exento) 01:7% 02:10% 03:15%
        valorITBMS: Number(data.fcd_itbms).toFixed(2),//Monto del ITBMS del ítem. Producto de TasaITBMS * PrecioItem
      });

      return {
        fcd_identificador: formFactura.fac_identificador,
        fcd_articulo: data.fcd_articulo,
        fcd_precio: data.fcd_precio,
        fcd_cantidad: data.fcd_cantidad,
        fcd_art_descripcion: data.art_descripcion,
        fcd_itbms_code: data.art_itbm_cod_v,
        fcd_itbms: Number(data.fcd_itbms).toFixed(2),
        fcd_descuento: data.fcd_descuento,
        fcd_total:Number(data.fcd_total).toFixed(2),
        fcd_entregado:montoEntregado,
        fcd_formapago:formDropDownFPago.frm_descripcion,
        fcd_descuento_number: data.fcd_descuento_number,
        fcd_sucursal:usr_sucursal,
        fcd_unique:formFactura.fac_identificador+"_"+data.fcd_articulo+"_"+i,
        // fcd_serie:data.ser_serie,
        // ser_id:data.ser_id
        fcd_serie: data?.fcd_serie ?? "",
        ser_id: data?.ser_id ? Number(data.ser_id) : null,
      };
    });
    vueltoR = new Decimal(totalValorRecibido).minus((new Decimal(totalPrecioNeto).minus(new Decimal(totaldescuento)).plus(totalITBMS)));
    var Objfactura_fpagoR=  Objfactura_fpago.map((datar)=>{
        if(datar.fcfp_number ==="02"){
          return {...datar,
            fcfp_monto:(new Decimal(datar.fcfp_monto).minus(new Decimal(vueltoR))).toFixed(2)
          }
        }
        return datar
      });
    retencion={
      codigoRetencion:formClientes.re_codigo.length>0?formClientes.re_codigo:"",
      montoRetencion:formClientes.re_codigo.length>0?roundNumber((Number(totalITBMS)*Number(formClientes.re_porc)),2).toFixed(2):"",//(TasaITBMS * TotalITBMS)
    };
    var body = { 
      formFactura: {
        fac_identificador: formFactura.fac_identificador,
        fac_cliente: formClientes.cli_id,
        fac_caja:formFactura.fac_caja===""?caj_id:formFactura.fac_caja,
        fac_vendedor:formFactura.fac_vendedor,
        fac_fecha:formFactura.fac_fecha,
        fac_unique:formFactura.fac_identificador,
        fac_sucursal:usr_sucursal,
        fac_punto_facturacion:punto_facturacion,
        fac_codigo_suc:com_suc_emisor,
        fac_itbms:roundNumber(totalITBMS,2),
        fac_total:new Decimal(totalPrecioNeto).minus(new Decimal(totaldescuento)).plus(new Decimal(totalITBMS)).toFixed(2),
        fac_recibo:usr_prints ==="3"?"0":"1",
        fac_sts:"0",
        fac_text_invoice:formFactura.fac_text_invoice
      },
      dataFacturaDetalle: dataFAC_detail,
      fcfp_factura_fpago:Objfactura_fpagoR,
      isCredit:isCreditV,
      isNc:false,
      cr_credito:{
        cr_cliente:formClientes.cli_id,	
        cr_sucursal:usr_sucursal
      },
      crd_credito_detalle:{
       crd_cliente:formClientes.cli_id,	
       crd_fac_identificador:formFactura.fac_identificador,	
       crd_monto:montoCredito,	
       crd_fecha:formFactura.fac_fecha,
       crd_itbms:totalITBMS,
       crd_retencion:retencion.montoRetencion,

      }

    };

    if(prefactura){
      var bodyFactura = {
        codigoSucursalEmisor:com_suc_emisor,
        cufeFEReferenciada:"",
        prefactura,
        res_mesa_id:formRestaurante.res_mesa_selected !== undefined?formRestaurante.res_nombre:"",
        tipoDocumento:"01",
        fac_anulacion:false,
        nota_credito:false,
        motivo_anulacion:"",
        fac_docn:formRestaurante.ord_number,
        punto_facturacion,
        fac_fecha:formFactura.fac_fecha,
        fac_text_invoice:formFactura.fac_text_invoice,
        cli_email:formClientes.cli_email.length>12?formClientes.cli_email:null,
        cli_ruc:formClientes.cli_ruc.trim().toUpperCase(),
        cli_name:formClientes.cli_nombre,
        cli_dv:formClientes.cli_dv,
        cli_direccion:formClientes.cli_direccion,
        frm_code:formDropDownFPago.frm_code,
        frm_descripcion:formDropDownFPago.frm_descripcion,
        listaItems:ObjItems,
        totaldescuento:Number(totaldescuento).toFixed(2),
        totalPrecioNeto:Number(totalPrecioNeto).toFixed(2),
        totalITBMS:Number(totalITBMS).toFixed(2),
        totalMontoGravado:Number(totalITBMS).toFixed(2),
        totalFactura:MONEY_ROUND(new Decimal(totalPrecioNeto).plus(new Decimal(totalITBMS))),////Suma de TotalTodosItems, TotalAcarreoCobrado, ValorSeguroCobrado menos TotalDescuento.
        totalTodosItems:MONEY_ROUND(new Decimal(totalPrecioNeto).plus(new Decimal(totalITBMS))),
        nroItems,
       retencion,
        valorCuotaPagada:MONEY_ROUND(new Decimal(totalPrecioNeto).plus(new Decimal(totalITBMS))),
        totalValorRecibido:totalValorRecibido.toFixed(2),//(Number(totalPrecioNeto) + Number(totalITBMS)).toFixed(2),
        vuelto: Number(vueltoR)<=0?"0.00":vueltoR.toFixed(2),//"0.00",
        print_type:usr_prints, //1. pdf, 2.recibo 3. recibo no fiscal
        informacionInteres: formGarantia.gr_descripcion+" "+" \n"+ dataCompania.com_info_interes+" "+" \n"+formRetencion.re_desc,
        listaFormaPago:ObjFPago,
        dataCompany,
        props_anulacion:[],
        facCopia:false,
      }
      post_facturaElectronica({data:bodyFactura,formRestaurante,isPost:false,data_fac_factura:body})
      var bodyOrden={
        ord_identificador:formRestaurante.current_ord_identificador,
        ord_number:formRestaurante.ord_number
      }
      put_ord_number(bodyOrden)

    }
    else{
      var result =  post_fac_factura(body);
      return result.then(async (data) => {
        if(data !== false){
          var bodyFactura = {
            codigoSucursalEmisor:com_suc_emisor,
            cufeFEReferenciada:"",
            prefactura,
            nota_credito:false,
            res_mesa_id:formRestaurante.res_mesa_selected !== undefined?formRestaurante.res_nombre:"",
            tipoDocumento:"01",
            fac_anulacion:false,
            motivo_anulacion:"",
            fac_id:data,
            punto_facturacion,
            fac_docn:data.toString().padStart(10, "0"),
            fac_fecha:formFactura.fac_fecha,
            fac_text_invoice:formFactura.fac_text_invoice,
            cli_email:formClientes.cli_email.length>12?formClientes.cli_email:null,
            cli_ruc:formClientes.cli_ruc.trim().toUpperCase(),
            cli_direccion:formClientes.cli_direccion,
            cli_name:formClientes.cli_nombre,
            cli_dv:formClientes.cli_dv,
            frm_code:formDropDownFPago.frm_code,
            frm_descripcion:formDropDownFPago.frm_descripcion,
            listaItems:ObjItems,
            totaldescuento:Number(totaldescuento).toFixed(2),
            totalPrecioNeto:new Decimal(totalPrecioNeto).minus(new Decimal(totaldescuento)).toFixed(2),
            totalITBMS:roundNumber(Number(totalITBMS),2).toFixed(2),
            totalMontoGravado:Number(totalITBMS).toFixed(2),
            totalFactura:MONEY_ROUND(new Decimal(totalPrecioNeto).minus(new Decimal(totaldescuento)).plus(new Decimal(totalITBMS))),////Suma de TotalTodosItems, TotalAcarreoCobrado, ValorSeguroCobrado menos TotalDescuento.
            totalTodosItems:MONEY_ROUND(new Decimal(totalPrecioNeto).minus(new Decimal(totaldescuento)).plus(new Decimal(totalITBMS))),
            nroItems,
            retencion,
            valorCuotaPagada:MONEY_ROUND(new Decimal(totalPrecioNeto).plus(new Decimal(totalITBMS))),
            totalValorRecibido:Number(totalValorRecibido).toFixed(2),//(Number(totalPrecioNeto) + Number(totalITBMS)).toFixed(2),
            vuelto:  Number(vueltoR)<=0?"0.00":vueltoR.toFixed(2),//"0.00",
            print_type:usr_prints, //1. pdf, 2.recibo 3. recibo no fiscal
            informacionInteres: usr_prints==="1"?formFactura.fac_text_invoice+" "+" \n"+formGarantia.gr_descripcion+" "+" \n"+ dataCompania.com_info_interes+" "+" \n"+formRetencion.re_desc:formGarantia.gr_descripcion+" "+" \n"+ dataCompania.com_info_interes+" "+" \n"+formRetencion.re_desc,
            listaFormaPago:ObjFPago,
            dataCompany,
            props_anulacion:[],
            facCopia:false,
          }
          var result = await post_facturaElectronica({data:bodyFactura,formRestaurante,isPost:true,data_fac_factura:body})
          return {
            data: bodyFactura,
            status: result
          };
        }
        
      })
    }
  }

function NC_FACTURA({dataCompania,items,formAnulacion,formClientes,usr_prints,formDropDownFPago,com_suc_emisor,usr_sucursal,punto_facturacion,caj_id}){
  var ObjItems = [];
  var ObjFPago = [];
  var totalPrecioNeto = 0;
  var totalITBMS = 0;
  var totaldescuento = 0;
  var totalValorRecibido = 0;
  var nroItems = 0;
  var vueltoR = 0;
  var montoEntregado = 0;
  var retencion = {
    codigoRetencion:"",
    montoRetencion:"",
  };
  
  var fac_identificador_val = moment(new Date()).format("YYYYMMDDHHmmssSSS");
  var dataCompany = SET_DATA_COMPANY({data:dataCompania});
  items.fPago.map((data,i)=>{
    ObjFPago.push({
      formaPagoFact:data.fcfp_number,
      descFormaPago:data.fcfp_number==="99"?data.fcfp_fpago:null,
      valorCuotaPagada:Number(data.fcfp_monto).toFixed(2),
      descFormaPagoR:data.fcfp_fpago })
    montoEntregado = new Decimal(data.fcfp_monto).plus(new Decimal(montoEntregado));
    totalValorRecibido = new Decimal(data.fcfp_monto).plus(new Decimal(totalValorRecibido));
  });

  var dataFAC_detail =  items.factura.map((data,i)=>{
    totalPrecioNeto = (new Decimal(data.fcd_cantidad).times(new Decimal(data.fcd_precio))).plus(totalPrecioNeto);//Suma de todas las ocurrencias de PrecioItem.3 decimales
    totalITBMS = new Decimal(data.fcd_itbms).plus(new Decimal (totalITBMS));//Suma de todas las ocurrencias de ValorITBMS. 3 decimales
    totaldescuento = new Decimal(data.fcd_descuento).plus(new Decimal (totaldescuento)); //3 decimales
    nroItems = nroItems + 1;
    ObjItems.push({
      descripcion: data.fcd_art_descripcion,
      codigo: data.art_upc.slice(0, 19),
      unidadMedida:"und",
      cantidad: Number(data.fcd_cantidad).toFixed(2),
      precioUnitario: Number(data.fcd_precio).toFixed(2),
      precioUnitarioDescuento:new Decimal(data.fcd_descuento).dividedBy(new Decimal(data.fcd_cantidad)).toFixed(2),
      precioItem:new Decimal(data.fcd_cantidad).times(new Decimal(data.fcd_precio).minus(new Decimal(data.fcd_descuento).dividedBy(new Decimal(data.fcd_cantidad)))).toFixed(2),//PrecioItem <> Cantidad * (PrecioUnitario - PrecioUnitarioDescuento)
      valorTotal:Number(data.fcd_total).toFixed(2),
      tasaITBMS:items.factura[0].cli_exento==="1"?"00":data.fcd_itbms_code,
      valorITBMS: Number(data.fcd_itbms).toFixed(2),//Monto del ITBMS del ítem. Producto de TasaITBMS * PrecioItem
    });

    return {
        fcd_identificador: fac_identificador_val,
        fcd_articulo: data.fcd_articulo,
        fcd_precio: data.fcd_precio,
        fcd_cantidad: data.fcd_cantidad,
        fcd_art_descripcion: data.art_descripcion,
        fcd_itbms_code: items.factura[0].cli_exento==="1"?"00": data.art_itbm_cod_v,
        fcd_itbms: Number(data.fcd_itbms).toFixed(2),
        fcd_descuento: data.fcd_descuento,
        fcd_total:Number(data.fcd_total).toFixed(2),
        fcd_entregado:montoEntregado,
        fcd_formapago:data.fcd_formapago,
        fcd_descuento_number: data.fcd_descuento_number,
        fcd_sucursal:data.fcd_sucursal,
        fcd_unique:fac_identificador_val+"_"+data.fcd_articulo+"_"+i
      };
  });

  vueltoR = new Decimal(totalValorRecibido).minus((new Decimal(totalPrecioNeto).minus(new Decimal(totaldescuento)).plus(totalITBMS)));
   var Objfactura_fpagoR =  items.fPago.map((datar)=>{
    if(datar.fcfp_number ==="02"){
      return {...datar,
        fcfp_monto:(new Decimal(datar.fcfp_monto)).toFixed(2)
      }
    }
    return datar
  });

  var body = { 
    formFactura: {
      fac_identificador: fac_identificador_val,
      fac_cliente: formAnulacion.cli_id,
      fac_caja:formAnulacion.fac_caja===""?caj_id:formAnulacion.fac_caja,
      fac_vendedor:formAnulacion.fac_vendedor,
      fac_fecha:formAnulacion.fac_fecha,
      fac_unique:fac_identificador_val,
      fac_doc_nc:formAnulacion.fac_id,
      fac_punto_facturacion:punto_facturacion,
      fac_codigo_suc:com_suc_emisor,
      fac_sucursal:usr_sucursal,
      fac_itbms:roundNumber(totalITBMS,2),
      fac_total:new Decimal(totalPrecioNeto).minus(new Decimal(totaldescuento)).plus(new Decimal(totalITBMS)).toFixed(2),
      fac_recibo:"1",
      fac_sts:"0",
      fac_text_invoice:formAnulacion.fac_text_invoice
    },
    dataFacturaDetalle: dataFAC_detail,
    fcfp_factura_fpago:Objfactura_fpagoR,
    isCredit:false,
    isNc:true,
  };

    var result =  post_fac_factura(body);
      return result.then(async (data) => {
        if(data !== false){
            var bodyFactura = {
            prefactura:false,
            tipoDocumento:"04",
            fac_anulacion:false,
            fac_fecha:formAnulacion.fac_fecha,
            cufeFEReferenciada:formAnulacion.fac_cufe,
            codigoSucursalEmisor:com_suc_emisor,
            motivo_anulacion:"",
            fac_id:data,
            fac_docn: formAnulacion.fac_id.toString().padStart(10, "0"),
            props_anulacion:{...formAnulacion,fac_date_anulacion:moment(new Date()).format("YYYY-MM-DD HH:mm:ss")},
            cli_email:null,
            nota_credito:false,
            punto_facturacion,
            cli_ruc:formAnulacion.cli_ruc.trim().toUpperCase(),
            cli_name:formAnulacion.cli_nombre,
            cli_dv:formAnulacion.cli_dv,
            cli_direccion:formAnulacion.cli_direccion,
            frm_code:formDropDownFPago.frm_code,
            frm_descripcion:formDropDownFPago.frm_descripcion,
            listaItems:ObjItems,
            totaldescuento:Number(totaldescuento).toFixed(2),
            totalPrecioNeto:new Decimal(totalPrecioNeto).minus(new Decimal(totaldescuento)).toFixed(2),
            totalITBMS:roundNumber(Number(totalITBMS),2).toFixed(2),
            totalMontoGravado:Number(totalITBMS).toFixed(2),
            totalFactura:MONEY_ROUND(new Decimal(totalPrecioNeto).minus(new Decimal(totaldescuento)).plus(new Decimal(totalITBMS))),////Suma de TotalTodosItems, TotalAcarreoCobrado, ValorSeguroCobrado menos TotalDescuento.
            totalTodosItems:MONEY_ROUND(new Decimal(totalPrecioNeto).minus(new Decimal(totaldescuento)).plus(new Decimal(totalITBMS))),
            res_mesa_id:"",
            fac_text_invoice:"",
            nroItems:nroItems,
            valorCuotaPagada:MONEY_ROUND(new Decimal(totalPrecioNeto).plus(new Decimal(totalITBMS))),
            totalValorRecibido:Number(totalValorRecibido).toFixed(2),//(Number(totalPrecioNeto) + Number(totalITBMS)).toFixed(2),
            retencion,
            vuelto:  Number(vueltoR)<=0?"0.00":vueltoR.toFixed(2),//"0.00",
            print_type:usr_prints, //1. pdf, 2.recibo 3. recibo no fiscal
            informacionInteres: "",
            listaFormaPago:ObjFPago,
            dataCompany,
            facCopia:false,
          };

              post_facturaElectronica({data:bodyFactura,formRestaurante:"",isPost:false,data_fac_factura:body})
            return true;
        }
        
      })
  }
  
  function ANULAR_FACTURA({formGarantia,usr_sucursal,dataCompania,formAnulacion,formClientes,usr_prints,formDropDownFPago,com_suc_emisor,punto_facturacion}){
    var dataCompany = SET_DATA_COMPANY({data:dataCompania})
    var  retencion={
      codigoRetencion:"",
      montoRetencion:"",
    };
    var body = {
      prefactura:false,
      tipoDocumento:"01",
      fac_anulacion:true,
      fac_fecha:formAnulacion.fac_fecha,
      codigoSucursalEmisor:com_suc_emisor,
      cufeFEReferenciada:"",
      motivo_anulacion:formAnulacion.motivo_anulacion,
      fac_docn: formAnulacion.fac_id.toString().padStart(10, "0"),
      props_anulacion:{...formAnulacion,fac_date_anulacion:moment(new Date()).format("YYYY-MM-DD HH:mm:ss")},
      cli_email:null,
      nota_credito:false,
      cli_ruc:formClientes.cli_ruc.trim().toUpperCase(),
      cli_name:formClientes.cli_nombre,
      cli_dv:formClientes.cli_dv,
      cli_direccion:formClientes.cli_direccion,
      frm_code:formDropDownFPago.frm_code,
      frm_descripcion:formDropDownFPago.frm_descripcion,
      listaItems:[],
      punto_facturacion,
      totalPrecioNeto:null,
      totalITBMS:null,
      totalMontoGravado:null,
      totalFactura:null,
      totalTodosItems:null,
      totaldescuento:null,
      res_mesa_id:"",
      fac_text_invoice:"",
      nroItems:null,
      valorCuotaPagada:null,
      totalValorRecibido:null,
      retencion,
      vuelto: null,//"0.00",
      print_type:usr_prints, //1. pdf, 2.recibo 3. recibo no fiscal
      informacionInteres: formGarantia.gr_descripcion+" \n"+ dataCompania.com_info_interes,
      listaFormaPago:[],
      dataCompany,
      facCopia:false,
      usr_sucursal
    };
    if(formAnulacion.motivo_anulacion.length>0){
     post_AnulacionElectronica(body,usr_prints)
     return true;
    }
    else{
     return false
    }
  }

  function PUT_CLIENTE({formClientes}){
    var body = {
      cli_id: formClientes.cli_id,
      cli_nombre: formClientes.cli_nombre,
      cli_direccion: formClientes.cli_direccion,
      cli_telefono: formClientes.cli_telefono,
      cli_telefono2: formClientes.cli_telefono2,
      cli_ruc: formClientes.cli_ruc.trim().toUpperCase(),
      cli_dv: formClientes.cli_dv,
      cli_email: formClientes.cli_email,
      cli_limitc: formClientes.cli_limitc,
      cli_credito: formClientes.cli_credito,
      cli_retencion:formClientes.re_id,
      cli_exento:formClientes.cli_exento,
    };
    put_cli_cliente(body);
  }
  function FOOTER_FACTURA_RESTAURANTE({
  subtotal = 0,
  itbms = 0,
  total = 0,
  moneda = "B/.",
  itbmsLabel = "ITBMS (7%)",
}) {
  const fmt = (n) => Number.parseFloat(n || 0).toFixed(2)

  return (
    <dl className="rt-totals">
      <div className="rt-total-row">
        <dt>Subtotal</dt>
        <dd>
          {moneda} {fmt(subtotal)}
        </dd>
      </div>
      <div className="rt-total-row">
        <dt>{itbmsLabel}</dt>
        <dd>
          {moneda} {fmt(itbms)}
        </dd>
      </div>
      <div className="rt-total-row grand">
        <dt>Total</dt>
        <dd>
          {moneda} {fmt(total)}
        </dd>
      </div>
    </dl>
  )
}
function FOOTER_FACTURA_COTIZACION({ enableTab, subtotal, itbms, total, usr_perfil }) {
  const subtotalValue = enableTab ? "0.00" : new Decimal(subtotal).toFixed(2);
  const itbmsValue = enableTab ? "0.00" : new Decimal(itbms).toFixed(2);
  const totalValue = enableTab ? "0.00" : new Decimal(total).toFixed(2);

  return (
    <Row className="justify-content-end g-2">
      <Col xs={12} sm={4} md={usr_perfil === "3" ? 4 : 2}>
        <div className="cot-total-box">
          <span className="cot-total-label">Subtotal</span>
          <strong className="cot-total-value">${subtotalValue}</strong>
        </div>
      </Col>

      <Col xs={6} sm={4} md={usr_perfil === "3" ? 4 : 2}>
        <div className="cot-total-box">
          <span className="cot-total-label">ITBMS</span>
          <strong className="cot-total-value">${itbmsValue}</strong>
        </div>
      </Col>

      <Col xs={6} sm={4} md={usr_perfil === "3" ? 4 : 2}>
        <div className="cot-total-box cot-total-main">
          <span className="cot-total-label">Total</span>
          <strong className="cot-total-value">${totalValue}</strong>
        </div>
      </Col>
    </Row>
  );
}
  function FOOTER_FACTURA({enableTab,subtotal,itbms,total,usr_perfil}){///usr_perfil 3. tablet
  //  total = new Decimal(total).decimalPlaces(2);
    return <>
    {window.innerWidth<=610? <>
      <Col xs={4}>
        <MDBInput
          className="input-iventario-totales"
          id="fcd_i_subtotal"
          wrapperClass="mb-2"
          label="SUBTOTAL"
          name="fcd_i_subtotal"
          value={enableTab ? [] : new Decimal(subtotal).toFixed(2)}
          disabled={true}
        />
      </Col>
      <Col xs={4}>
        <MDBInput
          className="input-iventario-totales"
          id="fcd_i_itbms"
          wrapperClass="mb-2"
          label="ITBMS"
          name="fcd_i_itbms"
          value={enableTab ? [] : new Decimal(itbms).toFixed(2)}
          disabled={true}
        />
      </Col>
      <Col xs={4}>
        <MDBInput
          className="input-iventario-totales"
          id="fcd_i_total"
          wrapperClass="mb-2"
          label="TOTAL"
          name="fcd_i_total"
          value={enableTab ? [] :new Decimal(total).toFixed(2)}
          disabled={true}
        />
      </Col>
    </>: <>
      <Col xs={usr_perfil==="3"?3:6}>
      </Col>
      <Col xs={usr_perfil==="3"?3:2}>
        <MDBInput
          className="input-iventario-totales"
          id="fcd_i_subtotal"
          wrapperClass="mb-2"
          label="SUBTOTAL"
          name="fcd_i_subtotal"
          value={enableTab ? [] : new Decimal(subtotal).toFixed(2)}
          disabled={true}
        />
      </Col>
      <Col xs={usr_perfil==="3"?3:2}>
        <MDBInput
          className="input-iventario-totales"
          id="fcd_i_itbms"
          wrapperClass="mb-2"
          label="ITBMS"
          name="fcd_i_itbms"
          value={enableTab ? [] : new Decimal(itbms).toFixed(2)}
          disabled={true}
        />
      </Col>
      <Col xs={usr_perfil==="3"?3:2}>
        <MDBInput
          className="input-iventario-totales"
          id="fcd_i_total"
          wrapperClass="mb-2"
          label="TOTAL"
          name="fcd_i_total"
          value={enableTab ? [] :new Decimal(total).toFixed(2)}
          disabled={true}
        />
      </Col>
    </> }

  </>
  }
  const VALIDAR_TOKEN = () => {
    var x = reactLocalStorage.getObject("tokenP");
    const hashDigest = sha256(nonce + x.usr_type + x.usr_id + x.usr_nombre);
    const hmacDigest = Base64.stringify(hmacSHA512(path + hashDigest, privateKey));
    if (x.key !== undefined) {
      if (x.key !== hmacDigest) 
        return true;
    }
    return false;
  };
  const OBTENER_TOKEN = ({usr_type,usr_id,usr_nombre})=>{
    const hashKey = sha256(nonce + usr_type+usr_id+usr_nombre);
    const hmacKey = Base64.stringify(hmacSHA512(path + hashKey, privateKey));
    return hmacKey
  }
  const FIND_DESC = (arr, elm,elm_id) => {
    const result = arr.find(function (item) {
      if (item.cli_ruc !== undefined) {
        if (item.cli_ruc.length>0) {
          if(elm_id===null){
            if (item.cli_ruc.toLowerCase().replace(/\s+/g, "") === elm.toLowerCase().replace(/\s+/g, ""))
            return true;
          }
          else{
            if (item.cli_ruc.toLowerCase().replace(/\s+/g, "") === elm.toLowerCase().replace(/\s+/g, "") && item.cli_id !== elm_id)
            return true;
          }
        }
      }
      if (item.prov_ruc !== undefined) {
        if (item.prov_ruc.length>0) {
          if(elm_id===null){
            if (item.prov_ruc.toLowerCase().replace(/\s+/g, "") === elm.toLowerCase().replace(/\s+/g, ""))
            return true;
          }
          else{
            if (item.prov_ruc.toLowerCase().replace(/\s+/g, "") === elm.toLowerCase().replace(/\s+/g, "") && item.prov_id !== elm_id)
            return true;
          }

        }
      }
      if (item.art_upc !== undefined) {
        if (item.art_upc.length>0) {
          if(elm_id===null){
            if (item.art_upc.toLowerCase().replace(/\s+/g, "") === elm.toLowerCase().replace(/\s+/g, ""))
            return true;
          }
          else{
            if (item.art_upc.toLowerCase().replace(/\s+/g, "") === elm.toLowerCase().replace(/\s+/g, "") && item.art_id !== elm_id)
            return true;
          }

        }
      }
    });
    if (result !== undefined) return true;
    else return false;
  };
  const EXPORT_CSV_ARTICULOS = ({dataArticulos}) => {
    var art= dataArticulos.map((data,i)=>{
      return window.innerWidth <= 611? {
        ID:data.art_id,
        Codigo: data.art_upc,
        Descripción: data.art_descripcion,
        Costo: data.art_costo,
        Precio: data.art_precio,
        Precio2: data.art_precio2,
        Precio3: data.art_precio3,
        Referencia: data.art_referencia,
        Serie:data.art_serie,
        Itbm_compra: data.art_itbm_compra,
      }: {
        ID:data.art_id,
        Codigo: data.art_upc,
        Descripción: data.art_descripcion,
        Cantidad: data.inv_qty,
        Costo: data.art_costo,
        Precio: data.art_precio,
        Precio2: data.art_precio2,
        Precio3: data.art_precio3,
        Categoria: data.cat_descripcion,
        Proveedor: data.prov_nombre,
        Marca:data.mar_descripcion,
        Bodega:data.bod_nombre,
        Referencia: data.art_referencia,
        Serie:data.art_serie,
        Linea_roja: data.art_linea_roja,
        Itbm_venta: data.art_itbm_venta,
        Itbm_compra: data.art_itbm_compra,
      }

    })
    const csvConfig = mkConfig({
      fieldSeparator: ',',
      decimalSeparator: '.',
      useKeysAsHeaders: true,
      filename: "base_de_datos_articulos"+moment(new Date()).format("_YYYY_MM_DD")+".csv",
    });
    const csv = generateCsv(csvConfig)(art);
    download(csvConfig)(csv);
  };
  const EXPORT_CSV_CREDITOS = ({dataCreditos}) => {
    var credito= dataCreditos.map((data,i)=>{
      return{
        ID:data.fac_id.toString().padStart(10, "0"),
        Cliente: data.cli_nombre,
        RUC: data.cli_ruc,
        Monto: data.crd_monto,
        Fecha: data.crd_fecha,
      }
    })
    const csvConfigCredito = mkConfig({
      fieldSeparator: ',',
      decimalSeparator: '.',
      useKeysAsHeaders: true,
      filename: "reporte_credito"+moment(new Date()).format("_YYYY_MM_DD")+".csv",
    });
    const csv = generateCsv(csvConfigCredito)(credito);
    download(csvConfigCredito)(csv);
  };
  const EXPORT_CSV_CREDITOS_PAGO = ({dataCreditospago}) => {
    var pago= dataCreditospago.map((data,i)=>{
      return{
        ID:data.fac_id.toString().padStart(10, "0"),
        Cliente: data.cli_nombre,
        RUC: data.cli_ruc,
        Monto: data.crp_monto,
        Fecha: data.crp_fecha,
        Eliminado: data.crp_fecha_delete,
      }
    })
  const csvConfigPago = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
    filename: "reporte_pago_credito"+moment(new Date()).format("_YYYY_MM_DD")+".csv",
  });
    const csv = generateCsv(csvConfigPago)(pago);
    download(csvConfigPago)(csv);
  };
  const EXPORT_CSV_GASTOS = ({dataGastos}) => {
    var gastos= dataGastos.map((data,i)=>{
      return{
        ID:data.gs_id,
        Sucursal: data.com_alias,
        Descripcion: data.gs_desc,
        Monto: data.gs_monto,
        Fecha: data.gs_fecha,
        Tipo_gasto: data.tgs_desc,
        nombre_documento: data.gs_imgName+""+data.gs_imgType,
      }
    })
  const csvConfigGastos = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
    filename: "reporte_gastos"+moment(new Date()).format("_YYYY_MM_DD"),
  });
    const csv = generateCsv(csvConfigGastos)(gastos);
    download(csvConfigGastos)(csv);
  };
  const FACTURA_ACTION_BTN = ({fetchReportX,setModalAnular,fetchListAnulacion,setErrorAnulacion,setModalCopiaF,fetchListFacImprimir,fetchCotizacionList,
    setModalCreditos,fetchCrCredito,fetchOrdenesList,usr_perfil,setFormRuc,setModalRuc,setDataRuc,dataCompania}) => {

    return<>
    {window.innerWidth<=610?<>
    <Row><Col xs={12} className="col-btn-reportes mt-2 mb-1">
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>fetchReportX()}>Informe</Button>
      {/* <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{setModalAnular(true); fetchListAnulacion(); setErrorAnulacion("")}}>Anulación & NC</Button> */}
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{setModalCopiaF(true);fetchListFacImprimir()}}>Facturas</Button>
      {dataCompania.com_version==="2" && <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{fetchCrCredito();setModalCreditos(true)}}>Créditos</Button>}
    </Col>
    <Col xs={12} className="col-btn-reportes mb-2">
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{fetchOrdenesList();}} >Ordenes</Button>
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{fetchCotizacionList()}}>Cotización</Button>
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{setFormRuc({ruc:"",dv:""});setModalRuc(true);setDataRuc({codigo:"",infoRuc:"",tipoRuc: "",ruc: "",dv:"",razonSocial:"",afiliadoFE:"", mensaje:"",resultado:""})}} >Consultar RUC</Button> 
    </Col>
    </Row>

    </>:<>
    {usr_perfil==="4"?<>
      {/* <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>fetchReportX()}>Informe X</Button> */}
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{setModalCopiaF(true);fetchListFacImprimir()}}>Facturas</Button>
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{fetchCotizacionList()}}>Cotizaciones</Button>
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{fetchOrdenesList();}} >Ordenes</Button>
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{setFormRuc({ruc:"",dv:""});setModalRuc(true);setDataRuc({codigo:"",infoRuc:"",tipoRuc: "",ruc: "",dv:"",razonSocial:"",afiliadoFE:"", mensaje:"",resultado:""})}} >Consultar RUC</Button> 
      <img src={LOGO_RESTAURANTE} className="logo-factura" alt="..." />
    </>:<>
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>fetchReportX()}>Informe X</Button>
      {/* <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{setModalAnular(true); fetchListAnulacion(); setErrorAnulacion("")}}>Anulación  & NC</Button> */}
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{setModalCopiaF(true);fetchListFacImprimir()}}>Facturas</Button>
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{fetchCotizacionList()}}>Cotizaciones</Button>
       {dataCompania.com_version==="2" && <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{fetchCrCredito();setModalCreditos(true)}}>Créditos</Button>}
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{fetchOrdenesList();}} >Ordenes</Button>
      <Button className=" btn-reporte_x button-color-dark" variant="contained" onClick={()=>{setFormRuc({ruc:"",dv:""});setModalRuc(true);setDataRuc({codigo:"",infoRuc:"",tipoRuc: "",ruc: "",dv:"",razonSocial:"",afiliadoFE:"", mensaje:"",resultado:""})}} >Consultar RUC</Button> 
       {dataCompania.com_logo==="1"?<img src={LOGO} className="logo-factura btn-reporte_x" alt="..." />:<img src={LOGO_2} className="logo-factura btn-reporte_x" alt="..." />}
    </>

    }
     
    </>}
</>
  };

  const ITEM_DETAIL_PANEL = ({SetOpenDetailItem,formDetailItem,existencia}) => {
     const { dataCompania } = useContext(StoreContext);
    return (
      window.innerWidth<=610?      <>
        <Col xs={12}>
          <Row>
             <Col xs={6} className="input-tablet">
              <MDBInput
                className="input-iventario"
                id="art_upc"
                wrapperClass="mb-3"
                label="Código"
                name="art_upc"
                autoFocus={true}
                value={formDetailItem.art_upc}
                disabled={true}
              />
            </Col>
            <Col xs={6} className="input-tablet">
              <MDBInput
                className="input-iventario"
                id="art_referencia"
                wrapperClass="mb-3"
                label="Referencia"
                name="art_referencia"
                autoFocus={true}
                value={formDetailItem.art_referencia}
                disabled={true}
              />
            </Col>
            <Col xs={12} className="input-tablet">
              <MDBInput
                className="input-iventario"
                id="art_descripcion"
                wrapperClass="mb-3"
                label="Descripción"
                name="art_descripcion"
                autoFocus={true}
                value={formDetailItem.art_descripcion}
                disabled={true}
              />
            </Col>
           
            <Col xs={6} className="input-tablet">
              <MDBInput
                className="input-iventario"
                id="mar_descripcion"
                wrapperClass="mb-3"
                label="Marca"
                name="mar_descripcion"
                autoFocus={true}
                value={formDetailItem.mar_descripcion}
                disabled={true}
              />
            </Col>
            <Col xs={6} className="input-tablet">
              <MDBInput
                className="input-iventario"
                id="cat_descripcion"
                wrapperClass="mb-3"
                label="Categoria"
                name="cat_descripcion"
                autoFocus={true}
                value={formDetailItem.cat_descripcion}
                disabled={true}
              />
            </Col>
            <Col xs={4} className="input-tablet">
              <MDBInput
                className="input-iventario"
                id="art_precio"
                wrapperClass="mb-3"
                label="PRECIO 1"
                name="art_precio"
                autoFocus={true}
                value={formDetailItem.art_precio}
                disabled={true}
              />
            </Col>
            <Col xs={4} className="input-tablet">
              <MDBInput
                className="input-iventario"
                id="art_precio2"
                wrapperClass="mb-3"
                label="PRECIO 2"
                name="art_precio2"
                autoFocus={true}
                value={formDetailItem.art_precio2}
                disabled={true}
              />
            </Col>
            <Col xs={4} className="input-tablet">
              <MDBInput
                className="input-iventario"
                id="art_precio3"
                wrapperClass="mb-3"
                label="PRECIO 3"
                name="art_precio3"
                autoFocus={true}
                value={formDetailItem.art_precio3}
                disabled={true}
              />
            </Col>
            {dataCompania.com_version==="2" && <Col xs={6} className="input-tablet">
              <MDBInput
                className="input-iventario"
                id="existencia"
                wrapperClass="mb-3"
                label="Existencia total"
                name="existencia"
                autoFocus={true}
                value={existencia}
                disabled={true}
              />
            </Col>}

          </Row>
        </Col>
        {dataCompania.com_version==="2" &&  <Col xs={12} key ={"123"}className="modal-add-inventario datatable-factura">
          <MaterialReactTable 
              muiTableBodyRowProps={({row}) => ({

                sx: {
                  backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                },
              })} 
              globalFilterFn="contains"
              muiTableContainerProps={{ sx: { maxHeight: '60vh' } }}
              layoutMode="grid" 
              renderEmptyRowsFallback={() => <Col xs={12} className="col-no-record"><Label className="label-no-record">No hay registros que mostrar</Label></Col>}
              
              enableEditing={false}
              enableColumnActions={false}
              editDisplayMode="cell"
              enableBottomToolbar={false} 
              enableTopToolbar={false}
              enableRowActions={false}
              positionActionsColumn="last"
              enablePagination={true}
              enableSorting={false}
              enableFilters={true} 
              enableStickyHeader={true}
              columns={COLUMNS_BODEGAS()}
              data={ formDetailItem.bodegas}
            />
          </Col>}
          <Col xs={12} className="text-center mt-2">
          {
            formDetailItem.art_imgName.length>0?<img src={imgURLocalImage+formDetailItem.art_imgName} className="w-art-cot2" alt="..."/>: null
          }
            
          </Col>
      </>:      <>
        <Col xs={12}>
          <Row>
            <Col xs={12} className="text-end mb-2">
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={() => SetOpenDetailItem(false)}
              ></MDBBtn>
            </Col>
             <Col xs={4}>
              <MDBInput
                className="input-iventario"
                id="art_upc"
                wrapperClass="mb-4"
                label="Código"
                name="art_upc"
                autoFocus={true}
                value={formDetailItem.art_upc}
                disabled={true}
              />
            </Col>
            <Col xs={6}>
              <MDBInput
                className="input-iventario"
                id="art_descripcion"
                wrapperClass="mb-4"
                label="Descripción"
                name="art_descripcion"
                autoFocus={true}
                value={formDetailItem.art_descripcion}
                disabled={true}
              />
            </Col>
           
            <Col xs={2}>
              <MDBInput
                className="input-iventario"
                id="mar_descripcion"
                wrapperClass="mb-4"
                label="Marca"
                name="mar_descripcion"
                autoFocus={true}
                value={formDetailItem.mar_descripcion}
                disabled={true}
              />
            </Col>
            <Col xs={2}>
              <MDBInput
                className="input-iventario"
                id="cat_descripcion"
                wrapperClass="mb-4"
                label="Categoria"
                name="cat_descripcion"
                autoFocus={true}
                value={formDetailItem.cat_descripcion}
                disabled={true}
              />
            </Col>
            <Col xs={2}>
              <MDBInput
                className="input-iventario"
                id="art_referencia"
                wrapperClass="mb-4"
                label="Referencia"
                name="art_referencia"
                autoFocus={true}
                value={formDetailItem.art_referencia}
                disabled={true}
              />
            </Col>
            <Col xs={2}>
              <MDBInput
                className="input-iventario"
                id="art_precio"
                wrapperClass="mb-4"
                label="PRECIO 1"
                name="art_precio"
                autoFocus={true}
                value={formDetailItem.art_precio}
                disabled={true}
              />
            </Col>
            <Col xs={2}>
              <MDBInput
                className="input-iventario"
                id="art_precio2"
                wrapperClass="mb-4"
                label="PRECIO 2"
                name="art_precio2"
                autoFocus={true}
                value={formDetailItem.art_precio2}
                disabled={true}
              />
            </Col>
            <Col xs={2}>
              <MDBInput
                className="input-iventario"
                id="art_precio3"
                wrapperClass="mb-4"
                label="PRECIO 3"
                name="art_precio3"
                autoFocus={true}
                value={formDetailItem.art_precio3}
                disabled={true}
              />
            </Col>
            <Col xs={2}>
              <MDBInput
                className="input-iventario"
                id="existencia"
                wrapperClass="mb-4"
                label="Existencia total"
                name="existencia"
                autoFocus={true}
                value={existencia}
                disabled={true}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={12} key ={"123"}className="modal-add-inventario datatable-factura">
          <MaterialReactTable 
              muiTableBodyRowProps={({row}) => ({

                sx: {
                  backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                },
              })} 
              globalFilterFn="contains"
              muiTableContainerProps={{ sx: { maxHeight: '60vh' } }}
              layoutMode="grid" 
              renderEmptyRowsFallback={() => <Col xs={12} className="col-no-record"><Label className="label-no-record">No hay registros que mostrar</Label></Col>}
              
              enableEditing={false}
              enableColumnActions={false}
              editDisplayMode="cell"
              enableBottomToolbar={false} 
              enableTopToolbar={false}
              enableRowActions={false}
              positionActionsColumn="last"
              enablePagination={true}
              enableSorting={false}
              enableFilters={true} 
              enableStickyHeader={true}
              columns={COLUMNS_BODEGAS()}
              data={ formDetailItem.bodegas}
            />
          </Col>
          <Col xs={12} className="text-center mt-4">
          {
            formDetailItem.art_imgName.length>0?<img src={imgURLocalImage+formDetailItem.art_imgName} className="w-art-cot2" alt="..."/>: null
          }
            
          </Col>
      </>

    );
  };

function FECHA_MENOR_7DIAS(fecha) {
  const hoy = moment();
  const fechaInput = moment(fecha);

  const dias = hoy.diff(fechaInput, "days");

  return dias <= 7;
}

  const MONEY_ROUND =(value) => {
    return new Decimal(String(value)).toDecimalPlaces(2, Decimal.ROUND_HALF_DOWN).toFixed(2);
  }
    const PANEL_VIEW_INVOICE = ({fac_selected,dataCopiaFactura,nc_flag,deleteRow}) => {
      var itbms=0;
      var total=0;
      dataCopiaFactura.factura.map((data)=>{
        itbms=itbms+Number(data.fcd_itbms);
        total=total+Number(data.fcd_total)
      })
    return (
      <Col className="modal-add-inventario datatable-factura  css_datatable1">
        <Row>
          <Col xs={12}>
            <Row>
              <Col xs={12} sm={4} className="input-tablet">
                <MDBInput
                  id="fac_selected"
                  wrapperClass="mb-2"
                  label="# Factura "
                  name="fac_selected"
                  value={fac_selected.toString().padStart(10, "0")}
                  disabled={true}/>
              </Col>
              <Col xs={12} sm={4} className="input-tablet">
                <MDBInput
                  id="cli_nombre"
                  wrapperClass="mb-2"
                  label="Cliente"
                  name="cli_nombre"
                  value={dataCopiaFactura.factura[0].cli_nombre}
                  disabled={true}/>
              </Col>
              <Col xs={12} sm={4} className="input-tablet">
                <MDBInput
                  id="cli_ruc"
                  wrapperClass="mb-2"
                  label="RUC"
                  name="cli_ruc"
                  value={dataCopiaFactura.factura[0].cli_ruc + dataCopiaFactura.factura[0].cli_dv}
                  disabled={true}/>
              </Col>
              <Col xs={12} className="input-tablet mb-2">
                <MDBTextArea 
                  id="fac_text_invoice"
                  name="fac_text_invoice"
                  label="* Descripción"
                  disabled={true}
                  rows={3}
                  value={dataCopiaFactura.factura[0].fac_text_invoice}/>
              </Col>
              {dataCopiaFactura.fPago.map((data)=>{
                return <>
                  <Col xs={8} className="input-tablet">
                    <MDBInput
                      id="fcfp_fpago"
                      wrapperClass="mb-2"
                      label="Forma de pago"
                      name="fcfp_fpago"
                      value={data.fcfp_fpago}
                      disabled={true}/>
                </Col>
                <Col xs={4} className="input-tablet">
                    <MDBInput
                      id="fcfp_monto"
                      wrapperClass="mb-2"
                      label="Monto"
                      name="fcfp_monto"
                      value={Number(data.fcfp_monto).toFixed(2)}
                      disabled={true}/>
                </Col>
                </>
              })}
              <Col xs={12} className="mb-2 mt-2 css_datatable1">
                <MaterialReactTable 
                  muiTableBodyRowProps={({ row }) => {
                    return {
                      sx: {
                        backgroundColor:row.id % 2 === 0 ? "#f0f0f0": "",
                        fontWeight: "bold",
                      },
                    };
                  }}
                  muiPaginationProps={{
                    showRowsPerPage: false
                  }}
                  renderEmptyRowsFallback={() => (
                    <Col xs={12} className="col-no-record">
                      <Label className="label-no-record">No hay registros que mostrar</Label>
                    </Col>
                  )}
                  muiSearchTextFieldProps={{
                    placeholder: "Buscar",
                  }}
                  displayColumnDefOptions={{
                    "mrt-row-actions": {
                      header: "OPCIONES",
                      size: window.innerWidth <= 370?80:70,
                      maxSize: window.innerWidth <= 370?80:70,
                      minSize: window.innerWidth <= 370?80:70,
                      muiTableBodyCellProps: {
                        sx: {
                          display: "flex",
                          justifyContent: "center",
                          // width:"70px",
                          alignItems: "center",
                          "& button": {
                            marginX:  window.innerWidth <= 430 ? "5px" : "1px", 
                          },
                        },
                      },
                      muiTableHeadCellProps: {
                        sx: {
                          textAlign: "center",
                        },
                      },
                    },
                  }}
                  renderRowActions={({ cell, row, table }) => (
                    <Box className="d-flex">
                      <IconButton onClick={() => deleteRow(row)}>
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  )}
                  globalFilterFn="contains"
                  muiTableContainerProps={{ sx: { maxHeight: window.innerWidth <= 611 ? window.innerWidth <= 430?window.innerWidth <= 370? "41dvh":"43dvh":"47dvh" : "55dvh" } }}//370w 420w, 611w, desktop
                  layoutMode="grid"
                  enableEditing={true}
                  enableColumnActions={true}
                  editDisplayMode="modal"
                  enableBottomToolbar={false}
                  enableTopToolbar={true}
                  enableRowActions={false}
                  positionActionsColumn="last"
                  enablePagination={false}
                  enableSorting={false}
                  enableFilters={true}
                  enableStickyHeader={true}
                  enableFullScreenToggle={false}
                  enableDensityToggle={false}
                  positionGlobalFilter="left"
                  columns={COLUMNS_FAC_FACTURA_DETALLE_COPIA()}
                  data={ dataCopiaFactura.factura}
                />
              </Col>
              <Col sm={3} md={3}>
              </Col>
              <Col xs={4} sm={3} md={3}>
                <MDBInput
                  className="input-iventario-totales"
                  id="fcd_i_subtotal"
                  wrapperClass="mb-2"
                  label="SUBTOTAL"
                  name="fcd_i_subtotal"
                  value={new Decimal(total).minus(new Decimal(itbms)).toFixed(2)}
                  disabled={true}
                />
              </Col>
              <Col xs={4} sm={3} md={3}>
                <MDBInput
                  className="input-iventario-totales"
                  id="fcd_i_itbms"
                  wrapperClass="mb-2"
                  label="ITBMS"
                  name="fcd_i_itbms"
                  value={new Decimal(itbms).toFixed(2)}
                  disabled={true}
                />
              </Col>
              <Col xs={4} sm={3} md={3}>
                <MDBInput
                  className="input-iventario-totales"
                  id="fcd_i_total"
                  wrapperClass="mb-2"
                  label="TOTAL"
                  name="fcd_i_total"
                  value={new Decimal(total).toFixed(2)}
                  disabled={true}
                />
              </Col>
            </Row>
            {/* :<Label>Cargando...</Label>} */}
          </Col>
    </Row>

    </Col>
    );
  };
export default function DetalleArticuloCotizacion({ formImg }) {
  return (
    <div className="cot-section">
      <div className="cot-section-header">
        <div className="cot-section-title">
          <MDBIcon fas icon="image" />

          <div>
            <strong>Detalle del artículo</strong>
            <span>Información e imagen del producto</span>
          </div>
        </div>
      </div>

      <Row className="g-3">
        <Col xs={12} md={6}>
          <label className="gm-field">
            <span className="gm-label">Descripción</span>
            <textarea
              className="gm-input gm-textarea"
              rows={2}
              value={formImg?.img_name || ""}
              disabled
              readOnly
            />
          </label>
        </Col>

        <Col xs={6} md={3}>
          <label className="gm-field">
            <span className="gm-label">Código</span>
            <input
              className="gm-input"
              value={formImg?.art_upc || ""}
              disabled
              readOnly
            />
          </label>
        </Col>

        <Col xs={6} md={3}>
          <label className="gm-field">
            <span className="gm-label">Referencia</span>
            <input
              className="gm-input"
              value={formImg?.art_referencia || ""}
              disabled
              readOnly
            />
          </label>
        </Col>

        <Col xs={4}>
          <label className="gm-field">
            <span className="gm-label">ITBMS</span>
            <input
              className="gm-input"
              value={Number(formImg?.cotd_itbms || 0).toFixed(2)}
              disabled
              readOnly
            />
          </label>
        </Col>

        <Col xs={4}>
          <label className="gm-field">
            <span className="gm-label">Descuento</span>
            <input
              className="gm-input"
              value={formImg?.cotd_descuento || ""}
              disabled
              readOnly
            />
          </label>
        </Col>

        <Col xs={4}>
          <label className="gm-field">
            <span className="gm-label">Cantidad</span>
            <input
              className="gm-input"
              value={formImg?.cotd_cantidad || ""}
              disabled
              readOnly
            />
          </label>
        </Col>

        <Col xs={12} className="text-center">
          {formImg?.imgUrl && (
            <img
              src={formImg.imgUrl}
              className="w-art-cot"
              alt={formImg?.img_name || "Artículo"}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}
function FORM_CLIENTE({error,loading,isEdit,handleClose,props,  onChange,  onClickBuscarRuc,  openRe,  anchorElRe,  handleClickRetencion,  handleCloseRetencion,  dataRetencion,  setFormClientes,  dataCompania}) {
  return (
    <>
      <MDBModalHeader className="gm-header">
        <div className="gm-header-title">
          <span className="gm-header-icon">
            <MDBIcon fas icon={isEdit ? "pen" : "user-plus"} />
          </span>
          <div>
            <h5 className="gm-title">
              {isEdit ? "Editar cliente" : "Nuevo cliente"}
            </h5>
            <p className="gm-subtitle">
              Datos generales del cliente
            </p>
          </div>
        </div>
        <button type="button" className="gm-close" aria-label="Cerrar" onClick={handleClose}>
          <MDBIcon fas icon="times" />
        </button>
      </MDBModalHeader>
      <MDBModalBody className="gm-body">
        <Row className="g-1">
          <Col xs={12} sm={6}>
            <label className="gm-field">
              <span className="gm-label">
                Nombre <span className="gm-req">*</span>
              </span>
              <input
                type="text"
                name="cli_nombre"
                className="gm-input"
                placeholder="Nombre o razón social"
                value={props.cli_nombre || ""}
                onChange={onChange}
                autoFocus/>
            </label>
          </Col>
          <Col xs={12}  sm={6}>
            <label className="gm-field">
              <span className="gm-label">E-mail</span>
              <input
                type="email"
                name="cli_email"
                className="gm-input"
                placeholder="correo@ejemplo.com"
                value={props.cli_email || ""}
                onChange={onChange} />
            </label>
          </Col>
          <Col xs={12}>
            <label className="gm-field">
              <span className="gm-label">Dirección</span>
              <input
                type="text"
                name="cli_direccion"
                className="gm-input"
                placeholder="Dirección del cliente"
                value={props.cli_direccion || ""}
                onChange={onChange} />
            </label>
          </Col>

          <Col xs={6}>
            <label className="gm-field">
              <span className="gm-label">Teléfono</span>
              <input
                type="text"
                name="cli_telefono"
                className="gm-input"
                placeholder="Teléfono principal"
                value={props.cli_telefono || ""}
                onChange={onChange} />
            </label>
          </Col>
          <Col xs={6}>
            <label className="gm-field">
              <span className="gm-label">Teléfono 2</span>
              <input
                type="text"
                name="cli_telefono2"
                className="gm-input"
                placeholder="Teléfono alternativo"
                value={props.cli_telefono2 || ""}
                onChange={onChange} />
            </label>
          </Col>
          <Col xs={9} md={10}>
            <div className="gm-field">
              <span className="gm-label">RUC</span>
              <div className="cliente-input-action">
                <input
                  type="text"
                  name="cli_ruc"
                  className="gm-input"
                  placeholder="RUC"
                  value={props.cli_ruc || ""}
                  onChange={onChange}/>
                <button
                  type="button"
                  className="cliente-action-btn"
                  title="Buscar RUC"
                  onClick={() =>
                    onClickBuscarRuc({
                      ruc: props.cli_ruc,
                      is_modal_ruc: false,
                    })
                  } >
                  <MDBIcon fas icon="search" />
                </button>
              </div>
            </div>
          </Col>
          <Col xs={3} md={2}>
            <label className="gm-field">
              <span className="gm-label">DV</span>
              <input
                type="number"
                min={1}
                max={99}
                name="cli_dv"
                className="gm-input"
                placeholder="DV"
                value={props.cli_dv || ""}
                onChange={onChange}
              />
            </label>
          </Col>
          <Col xs={12} md={dataCompania.com_version === "2" ? 12 : 12}>
            <div className="gm-field">
              <span className="gm-label">Retención</span>
              <div className="cliente-retencion-row">
                <button
                  type="button"
                  id="basic-button"
                  className="cliente-retencion-btn"
                  aria-controls={openRe ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openRe ? "true" : undefined}
                  onClick={handleClickRetencion}>
                  <MDBIcon fas icon="award" />
                  <span>
                    {props.re_desc?.length > 0
                      ? props.re_desc.slice(0, 30) + "..."
                      : "Seleccionar retención"}
                  </span>
                  <MDBIcon fas icon="chevron-down" />
                </button>
                <button
                  type="button"
                  className="cliente-clear-btn"
                  title="Quitar retención"
                  onClick={() =>
                    setFormClientes({
                      ...props,
                      re_id: "",
                      re_desc: "",
                      re_porc: "",
                      re_codigo: "",
                    })
                  } >
                  <MDBIcon fas icon="times" />
                </button>
              </div>
              <Menu
                id="basic-menu"
                anchorEl={anchorElRe}
                open={openRe}
                onClose={handleCloseRetencion}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                  className: "css-retencion",
                }} >
                {dataRetencion.map((data, i) => (
                  <MenuItem
                    key={i}
                    onClick={() => {
                      handleCloseRetencion();

                      setFormClientes({
                        ...props,
                        re_id: data.re_id,
                        re_desc: data.re_desc,
                        re_porc: data.re_porc,
                        re_codigo: data.re_codigo,
                      });
                    }}
                  >
                    {data.re_desc}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <label className="usuarios-permission exento-cliente">
              <input
                type="checkbox"
                name="cli_exento"
                onChange={onChange}
                value={props.cli_exento}
                checked={props.cli_exento === "1"}
              />

              <span className="usuarios-check">
                <MDBIcon fas icon="check" />
              </span>

              <span>Exento de ITBMS</span>
            </label>
          </Col>
          {dataCompania.com_version === "2" && (  <Col xs={12} md={4}>
            <label className="gm-field">
              <span className="gm-label">Límite de crédito</span>
              <input
                type="number"
                name="cli_limitc"
                className="gm-input"
                placeholder="0.00"
                value={props.cli_limitc || ""}
                onChange={onChange}
              />
            </label>
          </Col>
        )}
          </Row>
        </MDBModalBody>
    </>
  );
}
  export {
    FORM_CLIENTE,
    DetalleArticuloCotizacion,
    MONEY_ROUND,
    PANEL_VIEW_INVOICE,
    ITEM_DETAIL_PANEL,
    FACTURA_ACTION_BTN,
    EXPORT_CSV_CREDITOS_PAGO,
    EXPORT_CSV_CREDITOS,
    EXPORT_CSV_ARTICULOS,
    FOOTER_FACTURA,
    FOOTER_FACTURA_COTIZACION,
    VALIDAR_TOKEN,
    OBTENER_TOKEN,
    FIND_DESC,
    roundNumber,
    BODY_DC_COMPRA,
    format_miles,
    DC_UPDATE_CANTIDAD,
    BODY_RE_RECUENTO,
    BODY_MOV_MOVIMIENTO,
    RE_UPDATE_CANTIDAD,
    MOV_UPDATE_CANTIDAD,
    FORMATO_AM_PM,
    COPIA_FACTURA,
    GUARDAR_FACTURA,
    ANULAR_FACTURA,
    NC_FACTURA,
    PUT_CLIENTE,
    GUARDAR_ORDEN_RESTAURANTE,
    GUARDAR_ORDEN_NORMAL,
    EXPORT_CSV_GASTOS,
    FECHA_MENOR_7DIAS,
    FOOTER_FACTURA_RESTAURANTE
  };